import React, { useState } from "react";
import UserInfo from "./ego/pages/UserInfo";
import EgoTest from "./ego/pages/EgoTest";
import EgoResult from "./ego/pages/EgoResult";
import AdminLogin from "./ego/pages/AdminLogin";
import AdminPanel from "./ego/pages/AdminPanel";
import AccessGuard from "./access/AccessGuard";

function getInitialLanguage() {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get("slLang") || params.get("lang");
  return lang === "en" ? "en" : "tr";
}

export default function App() {
  const [stage, setStage] = useState("info");
  const [answers, setAnswers] = useState([]);
  const [durationMs, setDurationMs] = useState(null);
  const [language, setLanguage] = useState(getInitialLanguage);
  const [userInfo, setUserInfo] = useState(null);
  const [accessContext, setAccessContext] = useState(null);

  if (stage === "admin-login") {
    return (
      <AdminLogin
        lang={language}
        setLang={setLanguage}
        onSuccess={() => setStage("admin-panel")}
        onBack={() => setStage("info")}
      />
    );
  }

  if (stage === "admin-panel") {
    return (
      <AdminPanel
        lang={language}
        setLang={setLanguage}
        onBack={() => setStage("info")}
      />
    );
  }

  return (
    <>
      <div style={{ position: "fixed", top: 10, right: 10, zIndex: 20 }}>
        <button
          onClick={() => setStage("admin-login")}
          style={{
            background: "#444",
            color: "white",
            border: "none",
            padding: "6px 14px",
            borderRadius: "10px",
            cursor: "pointer",
          }}
        >
          Admin
        </button>
      </div>

      <AccessGuard language={language} onAccessReady={setAccessContext}>
        {stage === "info" && (
          <UserInfo
            language={language}
            setLanguage={setLanguage}
            onStart={(info) => {
              setUserInfo(info);
              setStage("test");
            }}
          />
        )}

        {stage === "test" && (
          <EgoTest
            language={language}
            onFinish={(ans, ms) => {
              setAnswers(ans);
              setDurationMs(ms);
              setStage("result");
            }}
          />
        )}

        {stage === "result" && (
          <EgoResult
            language={language}
            answers={answers}
            durationMs={durationMs}
            userInfo={userInfo}
            accessContext={accessContext}
          />
        )}
      </AccessGuard>
    </>
  );
}
